module.exports = __webpack_public_path__ + "7e6c150236aaeda452921749d8dc35d1.png";